export default __webpack_public_path__ + "static/media/payment.a882c071.svg";